import { Component } from "@angular/core";
import { ALLOWED_CHARACTERS } from "src/config/allowed-characters.config";
import { PrefixTextComponent } from "../../prefix-text.component";
import { TemplateTextComponent } from "../../templates/template-text/template-text.component";
import { MaxLength } from "../../types/MaxLength";

@Component({
  selector: "app-prefix-pas",
  imports: [TemplateTextComponent],
  templateUrl: "./prefix-pas.component.html",
  styleUrl: "./prefix-pas.component.less",
})
export class PrefixPasComponent extends PrefixTextComponent {
  public maxlength: MaxLength;

  public constructor() {
    super();
    this.maxlength = 11;
    this.characters = ALLOWED_CHARACTERS["pas"];
  }
}
